export default {"src":"/_next/static/media/0xa219439258ca9da29e9cc4ce5596924745e12b93.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};